import {AllergenSelectionStatus} from "@/models/Allergen/SelectedAllergen";

export enum AllergenSelectionStatusValue {
  ManuallyAdded = 0,
  DetectedByAI = 1,
  DetectedByAIDisabledManually = 2
}

const allergenSelectionStatusValuesByKey: Record<AllergenSelectionStatus, AllergenSelectionStatusValue> = {
  [AllergenSelectionStatus.ManuallyAdded]: AllergenSelectionStatusValue.ManuallyAdded,
  [AllergenSelectionStatus.DetectedByAI]: AllergenSelectionStatusValue.DetectedByAI,
  [AllergenSelectionStatus.DetectedByAIDisabledManually]: AllergenSelectionStatusValue.DetectedByAIDisabledManually
};

export function getAllergenSelectionStatusValue(status: AllergenSelectionStatus | number) {
  return typeof status === "number"
    ? status
    : allergenSelectionStatusValuesByKey[status] ?? AllergenSelectionStatusValue.ManuallyAdded;
}

export function normalizeAllergenSelectionStatus(status: AllergenSelectionStatus | number) {
  if (status === AllergenSelectionStatusValue.DetectedByAI) {
    return AllergenSelectionStatus.DetectedByAI;
  }

  if (status === AllergenSelectionStatusValue.DetectedByAIDisabledManually) {
    return AllergenSelectionStatus.DetectedByAIDisabledManually;
  }

  if (status === AllergenSelectionStatus.DetectedByAI || status === AllergenSelectionStatus.DetectedByAIDisabledManually) {
    return status;
  }

  return AllergenSelectionStatus.ManuallyAdded;
}